<template>
  <div
    class="grid justify-between"
    :class="{
      'grid-cols-4 sm:grid-cols-5 md:grid-cols-7 lg:grid-cols-8': small,
      'grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-5': !small
    }"
  >
    <div
      v-for="councillor in councillors"
      :key="councillor.id"
      :id="idGenerator && idGenerator(councillor.id)"
      @click="onClick(councillor.id)"
    >
      <person-icon
        :uid="''"
        :person="councillor"
        :show-name="true"
        :show-additional-role-title="false"
        :turncate-additional-role-title="true"
        :show-match-percent="false"
        :show-position="false"
        :truncate-name="small"
        :position="0"
        :candidateDraggable="false"
        :clone-on-drag="false"
        :small="small"
        :hasShadow="false"
        class="mx-auto"
      >
        <div class="px-1">
          <div
            class="pb-1 rounded-lg truncate text-white"
            :style="{
              backgroundColor: getVoteColor(councillor.decision)
            }"
          >
            <span class="text-chplus-xs w-full">{{
              getVoteLabel(councillor.decision)
            }}</span>
            <portrait
              :person="councillor"
              borderColor="#fff"
              :position="1"
              :small="small"
            ></portrait>
          </div>
        </div>
      </person-icon>
    </div>
  </div>
</template>

<script>
import PersonIcon from "@/components/people/PersonIcon";
import Portrait from "@/components/people/Portrait";
import { VoteMixin } from "@/utils/VoteMixin";

export default {
  name: "CouncillorGrid",
  components: { PersonIcon, Portrait },
  props: {
    councillors: {
      type: Array,
      required: true
    },
    idGenerator: {
      type: Function,
      required: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  mixins: [VoteMixin],
  methods: {
    onClick(councillorId) {
      this.$emit("clickedProfile", {
        councillorId
      });
    }
  }
};
</script>

<style scoped></style>
